import { pagination } from "./state";

const mutations = {
  setFetching: (state, payload) => {
    state.fetching = payload;
  },
  setOnSearch: (state, payload) => {
    state.search.onSearch = payload;
  },
  setSearchKey: (state, payload) => {
    state.search.key = payload;
  },
  setResponse: (state, payload) => {
    state.response = payload;
  },
  setDetailTransaksi: (state, { data }) => {
    state.detailTransaksi = data;
  },
  updateListTransaksi: (state, { data }) => {
    state.listTransaksi = state.listTransaksi.concat(data);
  },
  resetListTransaksi: (state) => {
    state.listTransaksi = [];
  },
  setTotalData: (state, { jumlah_nota }) => {
    state.totalData = jumlah_nota;
  },
  setOnFilter: (state, payload) => {
    state.onFilter = payload;
  },
  setUseToastSuccess: (state, payload) => {
    state.useToastSuccess = payload;
  },
  setLoadMore: (state, payload) => {
    state.loadMore = payload;
  },
  setExporting: (state, payload) => {
    state.exporting = payload;
  },
  setMinimizedExport: (state, payload) => {
    state.minimizedExport = payload;
  },
  setExportProgress: (state, { processed, total }) => {
    state.exportProgress.processed = Number(processed);
    state.exportProgress.total = Number(total);
  },
  setMultipleExport: (state, payload) => {
    state.multipleExport = payload;
  },
  setExportData: (state, payload) => {
    state.exportData = payload;
  },
  setExportDataLength: (state, payload) => {
    state.exportDataLength = payload;
  },
  // pagination
  setNextPagination: (state, { data }) => {
    state.pagination.length = data.length + state.listTransaksi.length;
    state.pagination.pageNumber++;
    state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
  },
  resetPagination: (state) => {
    state.pagination = pagination();
  },
};

export default mutations;
